"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import MissingData from "@/components/common/MissingData";
import Container from "@/components/common/container";

const NotFoundPage: React.FC = () => {
  const { t: ct } = useTranslation("common");

  return (
    <Container>
      <MissingData
        title={ct("notFound.title")}
        description={ct("notFound.subtitle")}
      />
    </Container>
  );
};

export default NotFoundPage;
